import Papa from 'papaparse'

type CellValue = string | number | boolean | null | undefined

export function downloadCsv(rows: CellValue[][], filename: string): void {
  const csv = Papa.unparse(rows)
  const BOM = '\uFEFF'
  const blob = new Blob([BOM + csv], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)

  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = filename.endsWith('.csv') ? filename : `${filename}.csv`
  anchor.click()

  URL.revokeObjectURL(url)
}
